import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ShopmyImage from '../General/ShopmyImage';
import { getSmartImage } from '../../helpers/helpers';
import {
  loadArtworkGrid,
  getCoverImageLogoContentBounds,
  getCoverImageLogoLayout,
  getCoverImageLogoLuminance,
  getCoverImageLogoMaskConfig,
  LOGO_CONTRAST_THRESHOLD
} from './featured_brand_artwork_helpers';

export default function FeaturedBrandArtwork({ logo, coverImage, size = 64, name = '', className = '' }) {
  const [samples, setSamples] = useState(null);
  const logoUrl = getSmartImage(logo);
  const coverUrl = getSmartImage(coverImage);
  useEffect(() => {
    let active = true;
    if (!coverUrl) return;
    Promise.all([loadArtworkGrid(logoUrl, 32), loadArtworkGrid(coverUrl, 24)]).then(([logoGrid, coverGrid]) => {
      if (active) setSamples({ logoUrl, coverUrl, logoGrid, coverGrid });
    });
    return () => {
      active = false;
    };
  }, [logoUrl, coverUrl]);
  const current = samples?.logoUrl === logoUrl && samples?.coverUrl === coverUrl ? samples : null;
  const bounds = current?.logoGrid ? getCoverImageLogoContentBounds(current.logoGrid) : undefined;
  const logoWidth = Math.min(128, size * 0.64);
  const logoHeight = (logoWidth * 52) / 128;
  const imageLayout = coverImage ? getCoverImageLogoLayout(bounds, logoWidth, logoHeight) : null;
  const luminance = getCoverImageLogoLuminance(current?.coverGrid, bounds, size, {
    coverWidth: size, coverHeight: size, logoWidth, logoHeight, overlayMultiplier: 0.8
  });
  const { shouldTint, layers } = getCoverImageLogoMaskConfig(bounds);
  const filter = coverImage && shouldTint ? `brightness(0)${luminance > LOGO_CONTRAST_THRESHOLD ? '' : ' invert(1)'}` : undefined;
  return (
    <div className={`featured-brand-cover-preview ${className}`} style={{ width: size, height: size }}>
      {coverImage && (
        <>
          <ShopmyImage className='featured-brand-cover-photo' source={coverImage} alt={name ? `${name} onboarding cover preview` : ''} />
          <div className='featured-brand-cover-shade' />
        </>
      )}
      <div className='featured-brand-cover-logo' style={{ width: logoWidth, height: logoHeight }}>
        {Array.from({ length: filter ? layers : 1 }, (_, index) => (
          <ShopmyImage
            key={index}
            source={logo}
            alt={!index && name ? `${name} logo overlay` : ''}
            style={{ position: 'absolute', width: '100%', height: '100%', objectFit: 'contain', ...imageLayout, filter }}
          />
        ))}
      </div>
    </div>
  );
}

FeaturedBrandArtwork.propTypes = {
  logo: PropTypes.string,
  coverImage: PropTypes.string,
  size: PropTypes.number,
  name: PropTypes.string,
  className: PropTypes.string
};
